module.exports = __webpack_public_path__ + "assets/rate.d8284c44.svg";